import axios from "axios";

export async function getStories({ payload, page, lang, isKidsApp }) {
  const ENDPOINT_URL = `/api/v1/${isKidsApp ? "young-citizen-" : ""}stories`;

  const response = await axios.post(
    `${ENDPOINT_URL}?page=${page}`,
    { ...payload },
    {
      headers: {
        "Accept-Language": lang,
      },
    }
  );
  return response?.data;
}
